var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"d":"M15,22H9c-0.6,0-1,0.4-1,1s0.4,1,1,1h6c0.6,0,1-0.4,1-1S15.6,22,15,22z"}}),_c('path',{attrs:{"d":"M12,0.4L1.9,13H8v6c0,0.6,0.4,1,1,1h6c0.6,0,1-0.4,1-1v-6h6.1L12,0.4z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }